import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lmc-env/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class PandadocService {
	private readonly uri: string = `${environment.DO_URL}/v2`;
	constructor(private readonly http: HttpClient) {}

	streamDocument(documentId: string): Observable<Blob> {
		return this.http.get(
			`${this.uri}/pandadocs/${encodeURIComponent(documentId)}/stream`,
			{ responseType: 'blob' }
		);
	}
}
